import styled from "styled-components";
import theme from "../../theme/theme";
import StrategiestItem from "./StrategiestItem";

const Wrapper = styled.ul`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  background-color: ${theme.colors.white};

  .linebreak {
    margin: 15px 0;
    width: 100%;
    border-bottom: 1px solid #e7eaed;
  }
`;

const StrategistsList = ({ strategists }) => {
  return (
    <Wrapper>
      {strategists.map((strategist, i) => (
        <li key={i}>
          <StrategiestItem
            strategistName={strategist.name}
            strategy={strategist.strategy}
            bioLink={strategist.biographyURL}
            invested={false}
            imgSrc={strategist.url}
            height={strategist.height}
          />
          <div className="linebreak"></div>
        </li>
      ))}
    </Wrapper>
  );
};

export default StrategistsList;
